import { render, staticRenderFns } from "./room.vue?vue&type=template&id=2deaac02&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"
import style0 from "./room.vue?vue&type=style&index=0&id=2deaac02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deaac02",
  null
  
)

export default component.exports